import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2368c12a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "full"
}
const _hoisted_2 = {
  key: 1,
  class: "full"
}

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";
import ValidationMessage from '@/components/UI/ValidationMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FlatOvalDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;
const dimensions = computed(() => store.getters.getMeasurements( 'flat-oval', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );
const message = computed(() => store.getters.getInstructionsForDimension);

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string|number) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const radius = computed({
	get: () => dimensions.value.radius,
	set: (value: string|number) => {
		store.dispatch(action, {
			dimension: "radius",
			value: value,
		});
	},
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "flat-oval-width",
        id: `${_ctx.prefix}measurements-flat-oval-width`,
        name: `${_ctx.prefix}measurements[dimensions][width]`,
        unit: "cm",
        label: dimensionLabel.value('width'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}flat-oval-width`),
        onBlur: () => _unref(addSizeToDataLayer)('width', +width.value, 'flat-oval'),
        modelValue: width.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((width).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "flat-oval-radius",
        id: `${_ctx.prefix}measurements-flat-oval-radius`,
        name: `${_ctx.prefix}measurements[dimensions][radius]`,
        unit: "cm",
        label: dimensionLabel.value('radius'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('radius'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}flat-oval-radius`),
        onBlur: () => _unref(addSizeToDataLayer)('radius', +radius.value, 'flat-oval'),
        modelValue: radius.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((radius).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      (message.value('width', 'radius', _ctx.isCutout))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ValidationMessage, { type: "notice" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(message.value('width', 'radius', _ctx.isCutout)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (message.value('radius', 'width', _ctx.isCutout))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(ValidationMessage, { type: "notice" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(message.value('radius', 'width', _ctx.isCutout)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})